var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-tabs',_vm._l((_vm.usages),function(usage){return _c('b-tab',{key:usage,attrs:{"title":_vm.InterviewUsage[usage]}},[_c('List',{attrs:{"fields":_vm.fields,"itemsFunction":function (currentPage, perPage) { return _vm.interviewsClient2.getAbstractInterviewsByUsage(
                usage,
                currentPage,
                perPage
              ); }},on:{"row-clicked":_vm.toDetail}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }